<template>
    <div class="footer">
        <div class="footerTop"/>
        <!-- <p class="footerNote">Developed by </p> -->
        <div class="CompanyLink">
                    <p class="footerNote" style="font-size:12px">Copyright </p><font-awesome-icon icon="copyright" size="sm"/>
                    <a href="https://unksagacious.com/" target="_blank" style = "display:inline-block;font-size:12px;padding-left:3px">  unksagacious.com </a>
        </div>

       
        
    </div>
</template>

<script>
export default {
  name: "KFooter",
  data:function (){
      return {
      }
  },
};


</script>



<style lang="scss">
#app .footer {
  background: white;;
    // position: fixed;
    // bottom: 0;
    width: 100%;
    padding: 0px;
    margin: 0px;
    // height: 50px;
}
#app .CompanyLink {
    display: inline-block;
}

#app .AboutUs {
// display: inline-block;
float: left;
}

#app .footerTop {
    border: none;
    padding: 0px;
    margin: 0px;
    height: 2px;
    /* Set the hr color */
    color: var(--theme-color); /* old IE */
    background-color: var(--theme-color); /* Modern Browsers */



}
#app .footerNote{
    margin: 5px;
    display:inline-block;
    margin-right:5px;
}



</style>
